import { postMobileAuthMessage } from "../mobileAuthBridge";

type TMobileMessageType =
  | "FLOW_COMPLETED"
  | "FLOW_CANCELLED"
  | "SHARE_PDF"
  | "FONT_SCALE_REQUEST"
  | "WEB_SCROLL_MODE";

type TMobilePayload = {
  data?: unknown;
  mode?: "internal" | "document";
  share?: { url: string; title?: string };
};

export const postMobileMessage = (type: TMobileMessageType, payload?: TMobilePayload) => {
  return postMobileAuthMessage(type, payload);
};
